import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(anexo) {
        return axiosJwt.delete(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/documentos/${anexo.idDocumentoInvestimentoPrevistoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(anexo) {
        const formData = new FormData()
        formData.append('descricao', anexo.descricao)
        formData.append('documento', anexo.documento)
        
        return axiosJwt
            .post(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/documentos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(anexo) {
        return axiosJwt.get(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/documentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    // obterProcesso(idContrato, idProcessoJudicialContrato) {
    //     return axiosJwt.get(`${api}/contratos/${idContrato}/processosjudiciais/${idProcessoJudicialContrato}`)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    download(anexo) {
        return axiosJwt
            .get(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/documentos/${anexo.idDocumentoInvestimentoPrevistoContrato}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
